import { render, staticRenderFns } from "./AiHelpMeWriteGeneratedContent.vue?vue&type=template&id=5a7b28bb&scoped=true"
import script from "./AiHelpMeWriteGeneratedContent.vue?vue&type=script&lang=js"
export * from "./AiHelpMeWriteGeneratedContent.vue?vue&type=script&lang=js"
import style0 from "./AiHelpMeWriteGeneratedContent.vue?vue&type=style&index=0&id=5a7b28bb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b28bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a7b28bb')) {
      api.createRecord('5a7b28bb', component.options)
    } else {
      api.reload('5a7b28bb', component.options)
    }
    module.hot.accept("./AiHelpMeWriteGeneratedContent.vue?vue&type=template&id=5a7b28bb&scoped=true", function () {
      api.rerender('5a7b28bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/Components/AiBuddy/AiHelpMeWriteGeneratedContent.vue"
export default component.exports